import { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Container } from 'react-bootstrap'
import logo from '../assets/logo.webp'
import caret from '../assets/caret.svg'
import trash from '../assets/trash.svg'
import download from '../assets/download.svg'
import { auth, db, storage } from '../firebase/setup'
import {
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  setPersistence,
  browserLocalPersistence,
} from 'firebase/auth'
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
  startAfter,
  deleteDoc,
  doc,
  getDoc,
} from 'firebase/firestore'
import { ref, listAll, getDownloadURL } from 'firebase/storage'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
pdfMake.addVirtualFileSystem(pdfFonts)

const Wrapper = styled.div`
  text-align: center;
  padding: 2em 0;
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`

const WrapperStandard = styled.div`
  text-align: center;
  padding: 2em 0;
  display: flex;
  flex-direction: column;
`

const Image = styled.img``

const InputWrapper = styled.div`
  width: 500px;
  text-align: left;

  &:first-of-type {
    margin-top: 40px;
  }
`

const InputLabel = styled.span`
  font-size: 16px;
  display: block;
  margin-top: 16px;
`

const Input = styled.input`
  width: 100%;
  background: transparent;
  border: 2px solid #fff;
  padding: 0.2em 0.5em;
  color: #fff;
  height: 35px;
  transition: 0.2s ease-in-out;
  margin-top: 4px;

  &:hover,
  &:focus {
    border-color: rgb(219, 179, 99);
  }
`

const Button = styled.button`
  background: ${(props) => (props.back ? 'transparent' : 'rgb(219, 179, 99)')};
  border: ${(props) => (props.back ? '2px solid rgb(219, 179, 99)' : 'none')};
  border-radius: 10px;
  padding: 0.5em 1.5em;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
  margin-right: ${(props) => (props.back ? '1em' : '0')};
  margin-top: 16px;
  width: 300px;

  &:hover {
    opacity: ${(props) => (props.back ? '1' : '0.85')};
    color: ${(props) => (props.back ? 'rgb(219, 179, 99)' : '#fff')};
  }
`

const BigTitle = styled.span`
  font-size: 36px;
  font-weight: 600;
  margin: 40px 0;
`

const LoadMore = styled.span`
  cursor: pointer;
  color: rgb(219, 179, 99);
  font-weight: 500;
  margin-top: 40px;
`

const Applicant = styled.div`
  margin-bottom: 16px;
  background: rgb(54, 52, 48);
  border-radius: 8px;
  height: ${(props) => (props.expanded ? 'auto' : '60px')};
  overflow: hidden;
  padding 0 2em;

  &:last-of-type {
    margin-bottom: 0;
  }
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;

  * {
    flex: 1;
    padding: 0;
  }
`

const Data = styled.div`
  padding-bottom: 2em;
  display: flex;

  * {
    flex: 1;
  }
`

const Name = styled.span`
  font-size: 26px;
  font-weight: 600;
  text-align: left;
`

const Info = styled.span`
  display: block;
  font-size: 16px;
  margin-bottom: 4px;

  &:last-of-type {
    margin-bottom: 0;
  }
`
const Bold = styled.span`
  font-weight: 500;
`

const DocTitle = styled.span`
  display: block;
  font-size: 16px;
  margin-bottom: 4px;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;

  &:last-of-type {
    margin-bottom: 0;
  }
`

const Caret = styled.img`
  cursor: pointer;
  height: 12px;
  transform: rotate(${(props) => (props.rotated ? '180deg' : '0')});
  transition: transform 0.3s ease-in-out;
`

const Section = styled.div`
  margin-top: ${(props) => (props.noMargin ? '4px' : '24px')};

  &:first-of-type {
    margin-top: 0;
  }
`

const SectionTitle = styled.span`
  display: block;
  color: rgb(219, 179, 99);
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 4px;
`

const Left = styled.div`
  text-align: left;
  padding-right: 2em;
`

const Right = styled.div`
  text-align: left;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  padding-left: 2em;
`

const Buttons = styled.div`
  text-align: right;
`

const Trash = styled.img`
  cursor: pointer;
  height: 18px;
  margin: 0 24px;
`

const Download = styled.img`
  cursor: pointer;
  height: 18px;
`

const Admin = () => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [user, setUser] = useState(null)
  const [applicants, setApplicants] = useState([])
  const [expanded, setExpanded] = useState(null)
  const [lastDoc, setLastDoc] = useState(null)
  const [hasMore, setHasMore] = useState(true)

  const deleteApplicant = async (id) => {
    const isConfirmed = window.confirm(
      'Are you sure you want to delete this applicant?'
    )

    if (!isConfirmed) {
      return
    }

    try {
      const docRef = doc(db, 'applicants', id)
      const docSnap = await getDoc(docRef)

      if (!docSnap.exists()) {
        alert('Error: Application not found')
        return
      }

      await deleteDoc(docRef)

      setApplicants((prev) => prev.filter((applicant) => applicant.id !== id))
    } catch (error) {
      console.error('Error deleting applicant:', error)
      alert('Failed to delete applicant. Please try again.')
    }
  }

  const load = async (loadMore = false) => {
    try {
      if (!loadMore) {
        setIsLoaded(false)
      }

      let q = query(
        collection(db, 'applicants'),
        orderBy('date', 'desc'),
        limit(20)
      )

      if (loadMore && lastDoc) {
        q = query(
          collection(db, 'applicants'),
          orderBy('date', 'desc'),
          startAfter(lastDoc),
          limit(20)
        )
      }

      const querySnapshot = await getDocs(q)

      if (querySnapshot.empty) {
        setHasMore(false)
        if (!loadMore) setIsLoaded(true)
        return
      }

      const lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1]
      setLastDoc(lastVisible)
      setHasMore(querySnapshot.docs.length === 20)

      const applicantsData = await Promise.all(
        querySnapshot.docs.map(async (doc) => {
          const data = doc.data()

          const [additionalDocument, coverLetter, resumeAndOther] =
            await Promise.all([
              listAll(ref(storage, `${data.id}/additional-document`)),
              listAll(ref(storage, `${data.id}/cover-letter`)),
              listAll(ref(storage, `${data.id}/resume-and-other-documents`)),
            ])

          return {
            ...data,
            additionalDocument: additionalDocument.items || [],
            coverLetter: coverLetter.items || [],
            resumeAndOtherDocuments: resumeAndOther.items || [],
          }
        })
      )

      setApplicants((prev) =>
        loadMore ? [...prev, ...applicantsData] : applicantsData
      )

      if (!loadMore) {
        setIsLoaded(true)
      }
    } catch (error) {
      console.error('Error loading applicants:', error)
      if (!loadMore) {
        setIsLoaded(true)
      }
    }
  }

  const downloadPdf = async (data) => {
    const content = [
      'Contact Information',
      `First name: ${data.firstName || '-'}`,
      `Last name: ${data.lastName || '-'}`,
      `Email: ${data.email || '-'}`,
      '\n',

      'Resume and Other Attachments',
      ...(data.resumeAndOtherDocuments.length > 0
        ? data.resumeAndOtherDocuments.map((doc) => doc.name)
        : ['-']),
      '\n',

      'Contact Details',
      `Address line 1: ${data.addressLineOne || '-'}`,
      `Address line 2: ${data.addressLineTwo || '-'}`,
      `City: ${data.city || '-'}`,
      `State: ${data.state || '-'}`,
      `Country: ${data.country || '-'}`,
      `Zip code: ${data.zipCode || '-'}`,
      `Phone: ${data.phone || '-'}`,
      '\n',

      'Cover Letter',
      data.cover
        ? data.cover
        : data.coverLetter.length > 0
        ? data.coverLetter.map((doc) => doc.name)
        : '-',
      '\n',

      'Additional Document',
      ...(data.additionalDocument.length > 0
        ? data.additionalDocument.map((doc) => doc.name)
        : ['-']),
      '\n',

      'Referral Source:',
      data.referralSource || '-',
      '\n',

      'Please identify "other" referral resource:',
      data.otherReferralSource || '-',
      '\n',

      'What is the position you’re applying for?',
      data.position || '-',
      '\n',

      'What is your salary expectation?',
      data.salaryExpectation || '-',
      '\n',

      'Are you willing to relocate?',
      data.relocate || '-',
      '\n',

      'Are you legally authorized to work in the United States?',
      data.workInUS || '-',
      '\n',

      'Have you been employed by Con-Real?',
      data.alreadyEmployed || '-',
      '\n',

      'Will you now or in the future require sponsorship for employment visa status (e.g. H-1B, TN, etc.)?',
      data.sponsorship || '-',
      '\n',

      'Have you ever pled "guilty" or "no contest" to, or been convicted of a crime?',
      data.crime || '-',
      '\n',

      'If yes, please provide date(s) and details.',
      data.crimeDetails || '-',
      '\n',
    ]

    if (data.experience && data.experience.length > 0) {
      content.push(
        'Prior Experience',
        ...data.experience
          .map((exp, index) => [
            `${index + 1}.`,
            `Company: ${exp.company || '-'}`,
            `Position: ${exp.position || '-'}`,
            `Start Date: ${exp.startDate ? format(exp.startDate) : '-'}`,
            `End Date: ${exp.endDate ? format(exp.endDate) : '-'}`,
            `Current Employer: ${exp.currentEmployer ? 'Yes' : 'No'}`,
            `May We Contact?: ${exp.contactEmployer ? 'Yes' : 'No'}`,
            `Ending Salary: ${exp.endingSalary || '-'}`,
            `What did you like about this position?: ${exp.details || '-'}`,
            `Reason For Leaving: ${exp.reasonForLeaving || '-'}`,
            '\n',
          ])
          .flat()
      )
    }

    if (data.education && data.education.length > 0) {
      content.push(
        'Applicant Education',
        ...data.education
          .map((edu, index) => [
            `${index + 1}.`,
            `Institution: ${edu.institution || '-'}`,
            `Type of Degree: ${edu.typeOfDegree || '-'}`,
            `Degree: ${edu.degree || '-'}`,
            `Major: ${edu.major || '-'}`,
            `Graduation Date: ${
              edu.graduationDate ? format(edu.graduationDate) : '-'
            }`,
            `Degree in Progress: ${edu.degreeInProgress ? 'Yes' : 'No'}`,
            '\n',
          ])
          .flat()
      )
    }

    if (data.license && data.license.length > 0) {
      content.push(
        'Professional License',
        ...data.license
          .map((lic, index) => [
            `${index + 1}.`,
            `Professional License: ${lic.professionalLicense || '-'}`,
            `Issuing State: ${lic.issuingState || '-'}`,
            `Other: ${lic.other || '-'}`,
            '\n',
          ])
          .flat()
      )
    }

    const docDefinition = {
      content: content,
    }

    const filename = `${data.firstName || 'Unknown'}_${
      data.lastName || 'Unknown'
    }_Application.pdf`

    pdfMake.createPdf(docDefinition).download(filename)
  }

  const downloadDoc = async (doc) => {
    const url = await getDownloadURL(doc)

    const link = document.createElement('a')
    link.href = url
    link.setAttribute('target', '_blank')
    link.setAttribute('download', doc.name)
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
  }

  useEffect(() => {
    if (user !== null) load(false)
  }, [user])

  const signIn = async () => {
    try {
      await setPersistence(auth, browserLocalPersistence)
      const user = await signInWithEmailAndPassword(auth, email, password)
      setUser(user.uid)
    } catch (error) {
      console.error('Error signing in:', error)
      alert('Failed to sign in. Please try again.')
    }
  }

  useEffect(() => {
    onAuthStateChanged(auth, (currentUser) => {
      if (currentUser === null) {
        setIsLoaded(true)
        return
      }

      if (currentUser.uid !== user) {
        setUser(currentUser.uid)
        setIsLoaded(true)
      }
    })
  }, [])

  const format = (date) => {
    return new Date(date.seconds * 1000).toLocaleDateString('en-US')
  }

  const loadMore = async () => {
    if (!isLoaded) return
    await load(true)
  }

  return isLoaded ? (
    user !== null ? (
      <Container>
        <WrapperStandard>
          <a href='https://www.con-real.com'>
            <Image src={logo} alt='Con-Real' />
          </a>

          <BigTitle onClick={() => signOut(auth)}>Applicants</BigTitle>

          {applicants.map((data) => (
            <Applicant key={data.id} expanded={data.id === expanded}>
              <Header>
                <Name>{data.firstName}</Name>
                <Info>
                  Submission Date:{' '}
                  <Bold>{new Date(data.date).toLocaleDateString('en-US')}</Bold>
                </Info>
                <Buttons>
                  <Download
                    src={download}
                    alt=''
                    onClick={() => downloadPdf(data)}
                  />
                  <Trash
                    src={trash}
                    alt=''
                    onClick={() => deleteApplicant(data.id)}
                  />
                  <Caret
                    src={caret}
                    alt=''
                    onClick={() =>
                      setExpanded((prev) => (prev === data.id ? null : data.id))
                    }
                    rotated={data.id === expanded}
                  />
                </Buttons>
              </Header>
              <Data>
                <Left>
                  <Section>
                    <Info>
                      First name: <Bold>{data.firstName || '-'}</Bold>
                    </Info>
                    <Info>
                      Last name: <Bold>{data.lastName || '-'}</Bold>
                    </Info>
                    <Info>
                      Email: <Bold>{data.email || '-'}</Bold>
                    </Info>
                  </Section>
                  <Section>
                    <SectionTitle>Resume and Other Attachments</SectionTitle>
                    {data.resumeAndOtherDocuments.length > 0 ? (
                      data.resumeAndOtherDocuments.map((doc) => (
                        <DocTitle
                          onClick={() => downloadDoc(doc)}
                          key={doc.name}
                        >
                          {doc.name}
                        </DocTitle>
                      ))
                    ) : (
                      <Info>
                        <Bold>-</Bold>
                      </Info>
                    )}
                  </Section>
                  <Section>
                    <SectionTitle>Contact Details</SectionTitle>
                    <Info>
                      Address line 1: <Bold>{data.addressLineOne || '-'}</Bold>
                    </Info>
                    <Info>
                      Address line 2: <Bold>{data.addressLineTwo || '-'}</Bold>
                    </Info>
                    <Info>
                      City: <Bold>{data.city || '-'}</Bold>
                    </Info>
                    <Info>
                      State: <Bold>{data.state || '-'}</Bold>
                    </Info>
                    <Info>
                      Country: <Bold>{data.country || '-'}</Bold>
                    </Info>
                    <Info>
                      Zip code: <Bold>{data.zipCode || '-'}</Bold>
                    </Info>
                    <Info>
                      Phone: <Bold>{data.phone || '-'}</Bold>
                    </Info>
                  </Section>
                  <Section>
                    <SectionTitle>Cover Letter</SectionTitle>
                    {data.cover ? (
                      <Info>
                        <Bold>{data.cover}</Bold>
                      </Info>
                    ) : data.coverLetter.length > 0 ? (
                      data.coverLetter.map((doc) => (
                        <DocTitle
                          onClick={() => downloadDoc(doc)}
                          key={doc.name}
                        >
                          {doc.name}
                        </DocTitle>
                      ))
                    ) : (
                      <Info>
                        <Bold>-</Bold>
                      </Info>
                    )}
                  </Section>
                  <Section>
                    <SectionTitle>Additional Document</SectionTitle>
                    {data.additionalDocument.length > 0 ? (
                      data.additionalDocument.map((doc) => (
                        <DocTitle
                          onClick={() => downloadDoc(doc)}
                          key={doc.name}
                        >
                          {doc.name}
                        </DocTitle>
                      ))
                    ) : (
                      <Info>
                        <Bold>-</Bold>
                      </Info>
                    )}
                  </Section>

                  <Section>
                    <SectionTitle>Referral Source:</SectionTitle>
                    <Info>
                      <Bold>{data.referralSource || '-'}</Bold>
                    </Info>
                  </Section>

                  <Section>
                    <SectionTitle>
                      Please identify "other" referral resource:
                    </SectionTitle>
                    <Info>
                      <Bold>{data.otherReferralSource || '-'}</Bold>
                    </Info>
                  </Section>

                  <Section>
                    <SectionTitle>
                      What is the position you’re applying for?
                    </SectionTitle>
                    <Info>
                      <Bold>{data.position || '-'}</Bold>
                    </Info>
                  </Section>

                  <Section>
                    <SectionTitle>
                      What is your salary expectation?
                    </SectionTitle>
                    <Info>
                      <Bold>{data.salaryExpectation || '-'}</Bold>
                    </Info>
                  </Section>

                  <Section>
                    <SectionTitle>Are you willing to relocate?</SectionTitle>
                    <Info>
                      <Bold>{data.relocate || '-'}</Bold>
                    </Info>
                  </Section>

                  <Section>
                    <SectionTitle>
                      Are you legally authorized to work in the United States?
                    </SectionTitle>
                    <Info>
                      <Bold>{data.workInUS || '-'}</Bold>
                    </Info>
                  </Section>

                  <Section>
                    <SectionTitle>
                      Have you been employed by Con-Real?
                    </SectionTitle>
                    <Info>
                      <Bold>{data.alreadyEmployed || '-'}</Bold>
                    </Info>
                  </Section>

                  <Section>
                    <SectionTitle>
                      Will you now or in the future require sponsorship for
                      employment visa status (e.g. H-1B, TN, etc.)?
                    </SectionTitle>
                    <Info>
                      <Bold>{data.sponsorship || '-'}</Bold>
                    </Info>
                  </Section>

                  <Section>
                    <SectionTitle>
                      Have you ever pled “guilty” or “no contest” to, or been
                      convicted of a crime?
                    </SectionTitle>
                    <Info>
                      <Bold>{data.crime || '-'}</Bold>
                    </Info>
                  </Section>

                  <Section>
                    <SectionTitle>
                      If yes, please provide date(s) and details.
                    </SectionTitle>
                    <Info>
                      <Bold>{data.crimeDetails || '-'}</Bold>
                    </Info>
                  </Section>
                </Left>
                <Right>
                  {data.experience.map((x, i) => (
                    <Section key={`exp-${data.id}-${i}`} noMargin={i > 0}>
                      {i === 0 && <SectionTitle>Prior Experience</SectionTitle>}
                      <SectionTitle>{i + 1}.</SectionTitle>
                      <Info>
                        Company: <Bold>{x.company || '-'}</Bold>
                      </Info>
                      <Info>
                        Position: <Bold>{x.position || '-'}</Bold>
                      </Info>
                      <Info>
                        Start Date:{' '}
                        <Bold>{x.startDate ? format(x.startDate) : '-'}</Bold>
                      </Info>
                      <Info>
                        End Date:{' '}
                        <Bold>{x.endDate ? format(x.endDate) : '-'}</Bold>
                      </Info>
                      <Info>
                        Current Employer:{' '}
                        <Bold>{x.currentEmployer ? 'Yes' : 'No'}</Bold>
                      </Info>
                      <Info>
                        May We Contact?:{' '}
                        <Bold>{x.contactEmployer ? 'Yes' : 'No'}</Bold>
                      </Info>
                      <Info>
                        Ending Salary: <Bold>{x.endingSalary || '-'}</Bold>
                      </Info>
                      <Info>
                        What did you like about this position?:{' '}
                        <Bold>{x.details || '-'}</Bold>
                      </Info>
                      <Info>
                        Reason For Leaving:{' '}
                        <Bold>{x.reasonForLeaving || '-'}</Bold>
                      </Info>
                    </Section>
                  ))}

                  {data.education.map((x, i) => (
                    <Section key={`edu-${data.id}-${i}`}>
                      {i === 0 && (
                        <SectionTitle>Applicant Education</SectionTitle>
                      )}
                      <SectionTitle>{i + 1}.</SectionTitle>
                      <Info>
                        Institution: <Bold>{x.institution || '-'}</Bold>
                      </Info>
                      <Info>
                        Type of Degree: <Bold>{x.typeOfDegree || '-'}</Bold>
                      </Info>
                      <Info>
                        Degree: <Bold>{x.degree || '-'}</Bold>
                      </Info>
                      <Info>
                        Major: <Bold>{x.major || '-'}</Bold>
                      </Info>
                      <Info>
                        Graduation Date:{' '}
                        <Bold>
                          {x.graduationDate ? format(x.graduationDate) : '-'}
                        </Bold>
                      </Info>
                      <Info>
                        Degree in Progress:{' '}
                        <Bold>{x.degreeInProgress ? 'Yes' : 'No'}</Bold>
                      </Info>
                    </Section>
                  ))}

                  {data.license.map((x, i) => (
                    <Section key={`lic-${data.id}-${i}`}>
                      {i === 0 && (
                        <SectionTitle>Professional License</SectionTitle>
                      )}
                      <SectionTitle>{i + 1}.</SectionTitle>
                      <Info>
                        Professional License:{' '}
                        <Bold>{x.professionalLicense || '-'}</Bold>
                      </Info>
                      <Info>
                        Issuing State: <Bold>{x.issuingState || '-'}</Bold>
                      </Info>
                      <Info>
                        Other: <Bold>{x.other || '-'}</Bold>
                      </Info>
                    </Section>
                  ))}
                </Right>
              </Data>
            </Applicant>
          ))}

          {hasMore && <LoadMore onClick={loadMore}>Load More</LoadMore>}
        </WrapperStandard>
      </Container>
    ) : (
      <Container>
        <Wrapper>
          <a href='https://www.con-real.com'>
            <Image src={logo} alt='Con-Real' />
          </a>

          <InputWrapper>
            <InputLabel>Email</InputLabel>
            <Input value={email} onChange={(e) => setEmail(e.target.value)} />
          </InputWrapper>

          <InputWrapper>
            <InputLabel>Password</InputLabel>
            <Input
              value={password}
              type='password'
              onChange={(e) => setPassword(e.target.value)}
            />
          </InputWrapper>

          <Button onClick={signIn}>Sign in</Button>
        </Wrapper>
      </Container>
    )
  ) : (
    <></>
  )
}

export default Admin
